import axios from "axios";
import {ordersServicesPath} from "../../../../Constants";


const estimateRestUrl = ordersServicesPath + '/customers/orders/'

export default class CustomerEstimateService {

    static async getAllByOrderId(orderId) {
        return axios.get(estimateRestUrl + orderId + '/estimates/by-order');
    }

    static async confirmPerformer(orderId, estimateId) {
        return await axios.patch(estimateRestUrl + orderId + '/confirm-performer?estimateId=' + estimateId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createOffers(orderId, names) {
        const namesQueryString = names.reduce((acc, el, id) => id === 0 ? `?nameOrganizations=${el}` : `${acc}&nameOrganizations=${el}`, "")
        return await axios.post(estimateRestUrl + orderId + '/estimates/create-offers' + namesQueryString, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createOffer(orderId, name) {
        return await axios.post(estimateRestUrl + orderId + '/estimates/create-offer?nameOrganization=' + name, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}